import axios from '../../../../config/axios';
import { OrderSchemaType } from '../AddOrder/order.schema';

const API_BASE_URL = `${process.env.REACT_APP_GATEWAY_BASE_URL}/steel-orders`;

export const fetchOrderById = async (orderId: string): Promise<OrderSchemaType> => {
  if (!orderId) {
    throw new Error('ID do pedido não fornecido.');
  }
  const { data } = await axios.get(`${API_BASE_URL}/order/${orderId}`);
  return data;
};